export class RenderLoop {
  constructor(tick) {
    this.tick = tick;
    this.running = false;
    this.prevT = 0;
    this.lastFrameMs = 0;
  }

  start() {
    this.running = true;
    this.prevT = performance.now();
    const step = (t) => {
      if (!this.running) return;
      this.lastFrameMs = t - this.prevT;
      this.prevT = t;
      this.tick(this.lastFrameMs);
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  stop() {
    this.running = false;
  }
}
